module.exports = __webpack_public_path__ + "media/images/btn_send_email-329bb6b366060427449c1ba3554f6a7e.gif";